import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'src/redux/store';
import {
  ICalendarDate,
  initialState,
  IOptionsDetailsData,
  ITicketDetails,
  ITripCalendarData,
  TTypeOption,
} from './interfaces';

export const calendarSlice = createSlice({
  name: 'calendar',
  initialState,
  reducers: {
    setData: () => {},
    setTripData: (
      state,
      action: PayloadAction<ITripCalendarData | undefined>
    ) => {
      // TO-DO valid dates
      const data = action.payload;
      if (!data) {
        state.tripData = action.payload;
        return;
      }
      const rates = data.rates.filter((i) => !+i.disabled);
      const schedules = data.schedules.filter((i) => !i.is_disabled);
      const tickets = data.tickets.filter((i) => !i.is_disabled_ts);
      const additional_options = data.additional_options.filter(
        (i) => !i.is_disabled && i.type === 'select'
      );
      const week = data.weekly.split(',').map((i) => +i);
      const type = tickets.length
        ? 'ticket'
        : schedules.length
        ? 'schedule'
        : additional_options.length
        ? 'option'
        : undefined;

      state.tripData = {
        ...data,
        schedules,
        tickets,
        additional_options,
        rates,
      };

      state.week = week;
      state.options.type = type;

      if (rates.length) {
        state.options.rate_id = rates[0].id;
      }

      if (type === 'ticket') {
        state.options.ticket_type = tickets[0].id;
      }

      if (type === 'option') {
        state.options.option_type = additional_options[0].id;
      }
    },
    setPartner: (state, action: PayloadAction<number | undefined>) => {
      if (state.options.partner_id === action.payload) return;
      state.options = {
        partner_id: action.payload,
        ...(!action.payload && { trip_id: state.options.trip_id }),
      };
    },
    setTrip: (state, action: PayloadAction<number | undefined>) => {
      console.log(action);
      if (state.options.trip_id === action.payload) return;
      state.options = {
        partner_id: state.options.partner_id,
        trip_id: action.payload,
      };
      state.tripData = undefined;
    },
    setRate: (state, action: PayloadAction<number | undefined>) => {
      if (state.options.rate_id === action.payload) return;
      state.options = {
        ...state.options,
        rate_id: action.payload,
      };
    },
    setType: (state, action: PayloadAction<TTypeOption>) => {
      if (state.options.type === action.payload) return;
      const trip = state.tripData;
      if (!trip) return;

      if (action.payload === 'ticket') {
        state.options.ticket_type = trip.tickets[0].id;
      }

      if (action.payload === 'option') {
        state.options.option_type = trip.additional_options[0].id;
      }

      state.options = {
        ...state.options,
        type: action.payload,
      };
    },
    setSchedulesIds: (state, action: PayloadAction<number[]>) => {
      state.options = {
        ...state.options,
        schedulesIds: action.payload,
      };
    },
    setDate: (
      state,
      action: PayloadAction<{
        idx: number;
        value: ICalendarDate;
      }>
    ) => {
      const { idx, value } = action.payload;
      state.dates[idx] = value;
    },
    addDate: (state, action: PayloadAction<ICalendarDate>) => {
      state.dates = [...state.dates, action.payload];
    },
    removeDate: (state, action: PayloadAction<string>) => {
      state.dates = state.dates.filter((i) => i.id !== action.payload);
    },
    setWeek: (state, action: PayloadAction<number>) => {
      const id = action.payload;
      const currentWeek = state.week || [];

      state.week = currentWeek.includes(id)
        ? currentWeek.filter((i) => i !== id)
        : [...currentWeek, id];
    },
    setOption: (state, action: PayloadAction<number>) => {
      if (state.options.option_type === action.payload) return;
      state.options = {
        ...state.options,
        option_type: action.payload,
      };
    },
    setTicket: (state, action: PayloadAction<number>) => {
      if (state.options.ticket_type === action.payload) return;
      state.options = {
        ...state.options,
        ticket_type: action.payload,
      };
    },
    setDetailsData: (state, action: PayloadAction<any>) => {
      state.detailsData = action.payload;
    },
    setDetailsTicketValue: (
      state,
      action: PayloadAction<{
        schedule_id: string;
        date: string;
        name: string;
        value: any;
      }>
    ) => {
      if (!state.detailsData) return;
      const { schedule_id, date, value, name } = action.payload;
      state.detailsData[schedule_id][date][name] = value;
    },
    setDetailsOptionValue: (
      state,
      action: PayloadAction<{
        date: string;
        name: string;
        value: any;
        idx?: number;
      }>
    ) => {
      if (!state.detailsData) return;
      const { idx, date, value, name } = action.payload;
      if (!idx && idx !== 0) {
        state.detailsData[date][name] = value;
        return;
      }
      state.detailsData[date].values[idx][name] = value;
      // state.detailsData[date].values = state.detailsData[date].values.map(
      //   (i: any, pos: number) => ({
      //     ...i,
      //     ...(pos === idx && { [name]: value }),
      //   })
      // );
    },
  },
});

export const {
  setData,
  setPartner,
  setTrip,
  setTripData,
  setType,
  setSchedulesIds,
  setDate,
  addDate,
  removeDate,
  setWeek,
  setOption,
  setTicket,
  setRate,
  setDetailsData,
  setDetailsTicketValue,
  setDetailsOptionValue,
} = calendarSlice.actions;

export const calendarOptions = (state: RootState) => state.calendar.options;

export const tripData = (state: RootState) => state.calendar.tripData;
export const calendarDates = (state: RootState) => state.calendar.dates;
export const calendarWeek = (state: RootState) => state.calendar.week;

export const allowBtns = (state: RootState) => {
  const { trip_id, rate_id, type, ticket_type, schedulesIds, option_type } =
    state.calendar.options;
  const trip = state.calendar.tripData;
  const dates = state.calendar.dates;
  const week = state.calendar.week;
  console.log({
    trip_id,
    rate_id,
    type,
    ticket_type,
    schedulesIds,
    option_type,
    use_rates: trip?.use_rates,
    use_schedule: trip?.use_schedule,
  });

  if (!trip || !trip_id)
    return {
      openCloseBtn: false,
      detailsBtn: false,
    };

  const isValid =
    Boolean(!trip.use_rates || (trip.use_rates && rate_id)) && //true
    Boolean(!trip.use_schedule || schedulesIds?.length || type === 'option') &&
    Boolean(type !== 'ticket' || ticket_type) &&
    Boolean(type !== 'option' || option_type) &&
    Boolean(dates[0].date_from && dates[0].date_to) &&
    Boolean(week?.length);

  return {
    openCloseBtn: isValid && type !== 'option' && !trip.is_integrated,
    detailsBtn: isValid,
  };
};

export const detailsTickets = (state: RootState) => state.calendar.detailsData;

export const normalisedData = (state: RootState) => {
  const { type } = state.calendar.options;
  if (type === 'option') {
    const data: IOptionsDetailsData = state.calendar.detailsData;

    if (!data) return [];
    const normaliseData = Object.keys(data).reduce((acc: any, curr) => {
      return {
        ...acc,
        [curr]: {
          calendar_id: data[curr].calendar_id,
          is_disabled: data[curr].is_disabled,
          values: data[curr].values,
        },
      };
    }, {});

    return [normaliseData];
  }
  return state.calendar.detailsData || [];
};

export default calendarSlice.reducer;
